import { DUTCH_TRANSLATIONS_PAGES } from '@app-pages/pages.translations';
import { DUTCH_TRANSLATIONS_SHARED } from '@app-shared/shared.translations';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

export class I18nTranslateLoader implements TranslateLoader {
  readonly translationMapping = new Map<string, Object>();

  constructor() {
    const { translationMapping } = this;
    translationMapping.set('nl', {
      ...DUTCH_TRANSLATIONS_SHARED,
      ...DUTCH_TRANSLATIONS_PAGES
    });
  }

  getTranslation(lang: string): Observable<Object> {
    const { translationMapping } = this;
    return of(translationMapping.get(lang));
  }
}
